(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/secondary-button.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/secondary-button.js');
"use strict";


const Button = svs.ui.Button;
const SecondaryButton = _ref => {
  let {
    children,
    onClick,
    transparent,
    disabled,
    className
  } = _ref;
  return React.createElement(Button, {
    className: "payfooter-button ".concat(className),
    disabled: disabled,
    inverted: !transparent,
    onClick: onClick,
    transparent: transparent
  }, children);
};
svs.tur.ReactPayfooter.SecondaryButton = SecondaryButton;

 })(window);